var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("資料連携")]),
      _c(
        "vab-collapse-info",
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.getFieldValue("demandBaseIdModel.title", _vm.info)) +
                " ［ " +
                _vm._s(
                  _vm.getFieldValue(
                    "purchaseOrderBaseIdModel.acceptOrderKey",
                    _vm.info
                  )
                ) +
                " ］ "
            ),
          ]),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _c("div", { staticClass: "flex_space width_100" }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "purchaseOrderBaseIdModel.buildingCdMbuildgpModel.blgsnmkj",
                                  _vm.info
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _c("div", { staticClass: "flex_space width_100" }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "demandBaseIdModel.itemCdModel.itmnm",
                                  _vm.info
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品明細")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    [
                      _c("div", { staticClass: "flex_space width_100" }, [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "purchaseOrderBaseIdModel.itemCdModel.itmdtlnm",
                                  _vm.info
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("セグメント")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "demandBaseIdModel.demandType",
                                _vm.info
                              ),
                              _vm.$divisions.demandTypeEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("案件分類")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "demandBaseIdModel.businessForm",
                                _vm.info
                              ),
                              _vm.$divisions.consignmentWorkClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("計上部門")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "demandBaseIdModel.accountingDepCdModel.orgkj",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行部門")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box", attrs: { span: 8 } },
                    [
                      _c(
                        "div",
                        { staticClass: "flex_space flex_center_align" },
                        [
                          _c("div", { staticClass: "flex_auto line_height" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getFieldValue(
                                    "purchaseOrderBaseIdModel.purchaseOrderDepCdModel.orgkj",
                                    _vm.info
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行担当者")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    _vm._l(
                      _vm.getFieldValue(
                        "purchaseOrderBaseIdModel.purchaseOrderChargePersonModelList",
                        _vm.info
                      ),
                      function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "empnmkj",
                                  item.chargePersonCdModel
                                )
                              ) +
                              " "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("協力会社")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "purchaseOrderBaseIdModel.supplierCdModel.bcnfrkj",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("納品予定年月")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFomateMonth(
                              _vm.getFieldValue(
                                "demandBaseIdModel.contractEndDate",
                                _vm.info
                              )
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "info_main" },
        [
          _c(
            "div",
            { staticClass: "head_box flex_start flex_center_align" },
            [
              _c("svg-icon", { attrs: { "icon-class": "edit_2_line" } }),
              _c("span", { staticClass: "hd_title" }, [
                _vm._v(_vm._s(_vm.showTitleByDemandType())),
              ]),
            ],
            1
          ),
          _c("vab-form", { ref: "form", attrs: { model: _vm.form } }, [
            _c(
              "div",
              { staticClass: "sure_box border_top_none border_bottom_none" },
              [
                _c(
                  "div",
                  { staticClass: "file_box norborder" },
                  [
                    _c(
                      "vab-row",
                      { staticClass: "row_box" },
                      [
                        _c(
                          "vab-col",
                          { staticClass: "title_box", attrs: { span: 4 } },
                          [
                            _c("div", { staticClass: "flex_colum" }, [
                              _c("div", { staticClass: "gyzl" }, [
                                _vm._v("共有資料"),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass:
                              "common_data_file word_box border_left_none",
                            attrs: { span: 20 },
                          },
                          [
                            _c("div", { staticClass: "common_data_file_box" }, [
                              _vm.fileList.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "word_col_upload_filebox" },
                                    _vm._l(
                                      _vm.fileList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass:
                                              "file_inner_item flex_start pl0",
                                            class: {
                                              disabled_file_name:
                                                _vm.disabledFileName(item),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "arrow_box" },
                                              [
                                                _c("svg-icon", {
                                                  staticClass: "arrow",
                                                  attrs: {
                                                    "icon-class":
                                                      "tryangle_right",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "file_name_out_box",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex_colum file_name_box",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "file_name",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.downLoad(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.fileName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "file_time",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " アップロード日時：" +
                                                            _vm._s(
                                                              item.createDate
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.formatTimeMsel(
                                                                item.createTime
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vab-row",
                      { staticClass: "row_box" },
                      [
                        _c(
                          "vab-col",
                          { staticClass: "title_box", attrs: { span: 4 } },
                          [_vm._v("コメント")]
                        ),
                        _c(
                          "vab-col",
                          { staticClass: "word_box", attrs: { span: 20 } },
                          [
                            _c("div", { staticClass: "pre_wrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getFieldValue("fileRemarks", _vm.info)
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }